/* tslint:disable */
/* eslint-disable */
/**
 * Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
import {
	ExperienceLevel,
	ExperienceLevelFromJSON,
	ExperienceLevelFromJSONTyped,
	ExperienceLevelToJSON,
} from "./ExperienceLevel";

/**
 *
 * @export
 * @interface PoliJobsContactDetailsAddUpdateDTO
 */
export interface PoliJobsContactDetailsAddUpdateDTO {
	/**
	 *
	 * @type {string}
	 * @memberof PoliJobsContactDetailsAddUpdateDTO
	 */
	phone?: string | null;
	/**
	 *
	 * @type {string}
	 * @memberof PoliJobsContactDetailsAddUpdateDTO
	 */
	personalEmail?: string | null;
	/**
	 *
	 * @type {ExperienceLevel}
	 * @memberof PoliJobsContactDetailsAddUpdateDTO
	 */
	experienceLevel?: ExperienceLevel;
	/**
	 *
	 * @type {string}
	 * @memberof PoliJobsContactDetailsAddUpdateDTO
	 */
	currentCompany?: string | null;
	/**
	 *
	 * @type {string}
	 * @memberof PoliJobsContactDetailsAddUpdateDTO
	 */
	currentPosition?: string | null;
}

export function PoliJobsContactDetailsAddUpdateDTOFromJSON(
	json: any
): PoliJobsContactDetailsAddUpdateDTO {
	return PoliJobsContactDetailsAddUpdateDTOFromJSONTyped(json, false);
}

export function PoliJobsContactDetailsAddUpdateDTOFromJSONTyped(
	json: any,
	ignoreDiscriminator: boolean
): PoliJobsContactDetailsAddUpdateDTO {
	if (json === undefined || json === null) {
		return json;
	}
	return {
		phone: !exists(json, "phone") ? undefined : json["phone"],
		personalEmail: !exists(json, "personalEmail")
			? undefined
			: json["personalEmail"],
		experienceLevel: !exists(json, "experienceLevel")
			? undefined
			: ExperienceLevelFromJSON(json["experienceLevel"]),
		currentCompany: !exists(json, "currentCompany")
			? undefined
			: json["currentCompany"],
		currentPosition: !exists(json, "currentPosition")
			? undefined
			: json["currentPosition"],
	};
}

export function PoliJobsContactDetailsAddUpdateDTOToJSON(
	value?: PoliJobsContactDetailsAddUpdateDTO | null
): any {
	if (value === undefined) {
		return undefined;
	}
	if (value === null) {
		return null;
	}
	return {
		phone: value.phone,
		personalEmail: value.personalEmail,
		experienceLevel: ExperienceLevelToJSON(value.experienceLevel),
		currentCompany: value.currentCompany,
		currentPosition: value.currentPosition,
	};
}
